exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.btn-primary[data-v-9f7f9f1a],button.btn-primary[data-v-9f7f9f1a]:hover{color:#fff;background-color:#0060d6;font-weight:500}div.run-connection-modal button.btn.close.close-modal[data-v-9f7f9f1a]{top:-40px;position:relative}div.run-connection-modal legend.close-modal[data-v-9f7f9f1a]{max-height:25px}div.run-connection-modal .modal-footer[data-v-9f7f9f1a]{padding:0}div.run-connection-modal .modal-footer>*[data-v-9f7f9f1a]{margin:0}#export-translations-modal .modal-dialog[data-v-9f7f9f1a]{position:relative}", ""]);

// exports
